/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type MutationAPIResponseV2 = {
  __typename: "MutationAPIResponseV2",
  status?: Status | null,
  error?: Error | null,
};

export enum Status {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}


export type Error = {
  __typename: "Error",
  message?: string | null,
};

export type DocumentBondedQuantity = {
  __typename: "DocumentBondedQuantity",
  documentId: string,
  totalBondedQuantity?: number | null,
};

export type SubmitManualClearingMutationVariables = {
  documentIds: Array< string >,
  reason: string,
  comment?: string | null,
};

export type SubmitManualClearingMutation = {
  submitManualClearing?:  {
    __typename: "MutationAPIResponseV2",
    status?: Status | null,
    error?:  {
      __typename: "Error",
      message?: string | null,
    } | null,
  } | null,
};

export type GetBondedQuantitiesByDocumentIdsQueryVariables = {
  documentIds: Array< string >,
};

export type GetBondedQuantitiesByDocumentIdsQuery = {
  getBondedQuantitiesByDocumentIds:  Array< {
    __typename: "DocumentBondedQuantity",
    documentId: string,
    totalBondedQuantity?: number | null,
  } >,
};
